import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditOutgoingPort = mutatorAction('updateAccountOutgoingPort', function (port) {
    var store = connectedAccountsStore();
    store.editAccountState.outgoingPort = port;
});
//# sourceMappingURL=updateEditOutgoingPort.js.map